import { DetailsComponent } from './../details/details.component';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';

import { environment } from '../../environments/environment';
import { APIURLS, SHAREDCONSTANTS } from '../_constants/constants';
import { NotificationDialogComponent } from './../notification/notification.dialog.component';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { TranslateService } from '../_services/translate.service';
import { TranslatePipe } from '../shared/translate/translate.pipe';
import { LoaderService } from '../_services/loader.service';

@Injectable()
export class McConnectService {
     // Resolve HTTP using the constructor
     constructor (private http: Http, private translate: TranslateService, private loaderService: LoaderService) {}         

     updateMcConnect(mcConnectVal: string, subValue: string, opcoValue: string, msisdn: string, ds: DialogService) {

        DetailsComponent.incrementRunningRequests();
        this.loaderService.display(true);

        const URL = (environment.BASE_URL_BACKEND + APIURLS.MC_CONNECT_Update_service).replace('{msisdn}', msisdn).replace('{status}', mcConnectVal);            
        const header = new Headers();
        header.append('content-type', 'application/json');
        header.append('selected-market', opcoValue);
        header.append('x-int-opco-id', opcoValue);
        const options = new RequestOptions({ headers: header, withCredentials: true });        
        this.http.put(URL, "", options).subscribe(
            response => {                
                ds.addDialog(NotificationDialogComponent, {
                    success: true,
                    message: new TranslatePipe(this.translate).transform('SUCCESS','GENERIC_MESSAGE')
                });
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
            },
            err => { 

                if(err.json().internalCode && this.translate.checkAPIErrorExistsByCode(err.json().internalCode)){
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform(err.json().internalCode,'API_ERROR')                   
                    });
                }
                else{
                    ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                    });
                }               
                // if(err.json().code == "IDP_ERROR"){
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: err.json().message
                //     });
                // }else{
                //     ds.addDialog(NotificationDialogComponent, {
                //         success: false,
                //         message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                //     });
                // }
                DetailsComponent.decrementRunningRequests();
                this.loaderService.display(false);
            }
        );

     }


     getMConnectStatus(subValue: string, opcoValue: string): Observable<any> {        
        
        const URL = (environment.BASE_URL_BACKEND + APIURLS.MC_CONNECT_Get_service).replace('{sub}', subValue);               

        const headers = new Headers();

        headers.append('Accept', 'application/json');
        headers.append('x-int-opco-id', opcoValue);
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');

        const options = new RequestOptions({ headers: headers, withCredentials: true });


         return this.http.get(URL, options).map(response => response.json());             
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/mcconnect.service.ts